/* eslint-disable react-native/no-inline-styles */
import * as S from './styles';
import React, {useState} from 'react';
import theme from '../../../global/styles/theme';
import TextDefault from '../../../components/TextDefault';
import {useDispatch, useSelector} from 'react-redux';
import {CommonActions, useNavigation} from '@react-navigation/native';
import {logoutAuth} from '../../../store/modules/user/actions';
import KeyboardScrollView from '../../../components/KeyboardScrollView';
import {StatusBarContainer} from '../../../components/StatusBar';
import Button from '../../../components/Button';
import {RootState} from '../../../store';
import {Alert, Linking, Platform, Text} from 'react-native';
import {Switch} from 'react-native';
import {
  // updateAppTheme,
  updateBiometric,
} from '../../../store/modules/config/actions';
import {deleteUser} from '../../../services/auth';
import { View } from 'react-native';
import DefaultModal from '../../../components/DefaultModal';

export default function ProfileScreen() {
  const userInfo = useSelector((state: RootState) => state?.user?.user);
  const appTheme = useSelector((state: RootState) => state.config.appTheme);
  const biometric = useSelector((state: RootState) => state.config.biometric);
  const navigation: any = useNavigation();
  const dispatch = useDispatch();

  // const [isEnabled, setIsEnabled] = useState(appTheme === 'dark');
  const [isBiometric, setIsBiometric] = useState(biometric);
  const [modalExcludedAccount, setModalExcludedAccount] = useState(biometric);

  // const toggleSwitchAppTheme = () => {
  //   // @ts-ignore
  //   dispatch(updateAppTheme(isEnabled ? 'light' : 'dark'));
  //   setIsEnabled(!isEnabled);
  // };

  const toggleSwitchBiometrics = () => {
    // @ts-ignore
    dispatch(updateBiometric(!isBiometric));
    setIsBiometric(!isBiometric);
  };

  const allOptions = [
    {
      id: 1,
      label: 'Financeiro',
      icon: 'bar-chart',
    },
    {
      id: 2,
      label: 'Editar perfil',
      icon: 'edit',
    },
    {
      id: 3,
      label: 'Recuperar senha',
      icon: 'password',
    },
    {
      id: 4,
      label: 'Política de privacidade',
      icon: 'privacy-tip',
    },
    {
      id: 5,
      label: 'Termos de uso',
      icon: 'description',
    },
    {
      id: 6,
      label: 'Obter suporte',
      icon: 'contact-support',
    },
    {
      id: 7,
      label: 'Solicitar encerramento da conta',
      icon: 'cancel',
    },
  ];

  const applyLogout = () => {
    // @ts-ignore
    dispatch(logoutAuth());
    return navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{name: 'LoginScreen'}],
      }),
    );
  };

  const deleteAccount = async () => {
    await deleteUser(userInfo?.user?.id, userInfo?.token);
    applyLogout();
  };

  const onPressOption = (option: any) => {
    if (option.id === 1) {
      return navigation.navigate('ExtractScreen');
    }
    if (option.id === 2) {
      return navigation.navigate('EditProfileScreen');
    }
    if (option.id === 3) {
      return navigation.navigate('ChangePasswordScreen');
    }
    if (option.id === 4) {
      return Linking.openURL(
        'https://dsstoken.sfo3.digitaloceanspaces.com/documents/termos-de-uso.pdf',
      );
    }
    if (option.id === 5) {
      return Linking.openURL(
        'https://dsstoken.sfo3.digitaloceanspaces.com/documents/privacidade.pdf',
      );
    }
    if (option.id === 6) {
      const url = 'whatsapp://send?phone=+558541013011';
      return Linking.openURL(url);
    }
    if (option.id === 7) {
      return setModalExcludedAccount(true);
    }
  };

  return (
    <>
      <StatusBarContainer />
      <S.Container appTheme={appTheme}>
        {!userInfo?.user?.id ? (
          <S.ContainerArea appTheme={appTheme}>
            <Button
              title="FAZER LOGIN"
              onPress={applyLogout}
              fontFamily={theme.fonts.family.opensans.bold}
              backgroundColor={theme.colors(appTheme).backgroundLogout}
              fontColor={theme.colors(appTheme).white}
              width={200}
              height={50}
            />
          </S.ContainerArea>
        ) : (
          <S.ContainerArea appTheme={appTheme}>
            <KeyboardScrollView justifyContent="flex-start">
              <S.Body>
                <TextDefault
                  fontSize={20}
                  color={theme.colors(appTheme).white}
                  marginBottom={20}
                  text="Informações da Conta"
                  fontFamily={theme.fonts.family.opensans.semi_bold}
                />
                <S.Box appTheme={appTheme}>
                  <S.ItemOptionHeader>
                    <TextDefault
                      fontSize={14}
                      color={theme.colors(appTheme).white}
                      text="Nome do usuário"
                      fontFamily={theme.fonts.family.opensans.semi_bold}
                    />
                    <TextDefault
                      fontSize={14}
                      color={theme.colors(appTheme).white}
                      text={userInfo?.user?.name}
                      fontFamily={theme.fonts.family.opensans.semi_bold}
                      style={{maxWidth: '50%'}}
                    />
                  </S.ItemOptionHeader>
                  <S.ItemOptionHeader>
                    <TextDefault
                      fontSize={14}
                      color={theme.colors(appTheme).white}
                      text="E-mail"
                      fontFamily={theme.fonts.family.opensans.semi_bold}
                    />
                    <TextDefault
                      fontSize={14}
                      color={theme.colors(appTheme).white}
                      text={userInfo?.user?.email}
                      fontFamily={theme.fonts.family.opensans.semi_bold}
                      style={{maxWidth: '80%'}}
                    />
                  </S.ItemOptionHeader>
                  {/* <S.ItemOptionHeader>
                    <TextDefault
                      fontSize={14}
                      color={theme.colors(appTheme).white}
                      text="Ativar modo noturno"
                      fontFamily={theme.fonts.family.opensans.semi_bold}
                    />
                    <Switch
                      trackColor={{
                        true: theme.colors(appTheme).gray[650],
                        false: theme.colors(appTheme).gray[800],
                      }}
                      thumbColor={
                        isEnabled
                          ? theme.colors(appTheme).main[700]
                          : theme.colors(appTheme).gray[50]
                      }
                      ios_backgroundColor={theme.colors(appTheme).gray[800]}
                      onValueChange={toggleSwitchAppTheme}
                      value={isEnabled}
                    />
                  </S.ItemOptionHeader> */}
                  {/* <S.ItemOptionHeader>
                    <TextDefault
                      fontSize={14}
                      color={theme.colors(appTheme).white}
                      text={`Ativar ${
                        Platform.OS === 'android' ? 'Biometria' : 'Face ID'
                      }`}
                      fontFamily={theme.fonts.family.opensans.semi_bold}
                    />
                    <Switch
                      trackColor={{
                        true: theme.colors(appTheme).gray[650],
                        false: theme.colors(appTheme).gray[800],
                      }}
                      thumbColor={
                        isBiometric
                          ? theme.colors(appTheme).main[700]
                          : theme.colors(appTheme).gray[50]
                      }
                      ios_backgroundColor={theme.colors(appTheme).gray[800]}
                      onValueChange={toggleSwitchBiometrics}
                      value={isBiometric}
                    />
                  </S.ItemOptionHeader> */}
                </S.Box>
                {allOptions.map(option => (
                  <S.ItemOption
                    key={option.id}
                    onPress={() => onPressOption(option)}>
                    <S.Row>
                      <S.IconImage
                        color={theme.colors(appTheme).white}
                        size={22}
                        name={option.icon}
                      />
                      <TextDefault
                        fontSize={14}
                        color={theme.colors(appTheme).white}
                        text={option.label}
                        fontFamily={theme.fonts.family.opensans.semi_bold}
                      />
                    </S.Row>
                    <S.IconImage
                      color={theme.colors(appTheme).text}
                      size={14}
                      name="arrow-forward-ios"
                    />
                  </S.ItemOption>
                ))}
                <S.ButtonAction>
                  <Button
                    title="Sair"
                    onPress={applyLogout}
                    fontFamily={theme.fonts.family.opensans.bold}
                    backgroundColor={theme.colors(appTheme).backgroundLogout}
                    fontColor={theme.colors(appTheme).white}
                    width={100}
                  />
                </S.ButtonAction>
                <View>
                  <Text style={{ color: 'transparent' }}>dss exchange</Text>
                </View>
              </S.Body>
            </KeyboardScrollView>
          </S.ContainerArea>
        )}
        <DefaultModal
          modalVisible={modalExcludedAccount}
          setModalVisible={setModalExcludedAccount}
          onClose={() => {
            setModalExcludedAccount(false);
          }}>
          <S.ContainerModal appTheme={appTheme}>
            <S.Body style={{ width: '100%' }}>
              <TextDefault
                fontSize={20}
                color={theme.colors(appTheme).white}
                marginBottom={10}
                text="Exclusão de conta"
                fontFamily={theme.fonts.family.opensans.semi_bold}
              />
              <TextDefault
                fontSize={14}
                color={theme.colors(appTheme).white}
                marginBottom={20}
                text="Tem certeza que deseja excluir permanentemente sua conta?"
                fontFamily={theme.fonts.family.opensans.semi_bold}
                textAlign="center"
              />
              <View style={{ flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                <Button
                  title="Cancelar"
                  onPress={() => {
                    setModalExcludedAccount(false);
                  }}
                  fontFamily={theme.fonts.family.opensans.bold}
                  width="45%"
                  height={40}
                />
                <Button
                  title="EXCLUIR"
                  onPress={deleteAccount}
                  fontFamily={theme.fonts.family.opensans.bold}
                  fontColor={theme.colors(appTheme).white}
                  backgroundColor={theme.colors(appTheme).red[500]}
                  width="45%"
                  height={40}
                />
              </View>
            </S.Body>
          </S.ContainerModal>
        </DefaultModal>
      </S.Container>
    </>
  );
}
